import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlert = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.75863 1.94762C8.68373 1.81202 8.57385 1.69897 8.44042 1.62025C8.307 1.54152 8.15492 1.5 8 1.5C7.84508 1.5 7.693 1.54152 7.55958 1.62025C7.42616 1.69897 7.31627 1.81202 7.24137 1.94762L1.60796 12.3478C1.53511 12.4797 1.49793 12.6284 1.50009 12.7791C1.50225 12.9298 1.54367 13.0773 1.62027 13.2071C1.69687 13.3369 1.806 13.4445 1.93688 13.5193C2.06776 13.594 2.21587 13.6333 2.36659 13.6333H13.6334C13.7841 13.6333 13.9322 13.594 14.0631 13.5193C14.194 13.4445 14.3031 13.3369 14.3797 13.2071C14.4563 13.0773 14.4978 12.9298 14.4999 12.7791C14.5021 12.6284 14.4649 12.4797 14.392 12.3478L8.75863 1.94762Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 11.0333C8.05746 11.0333 8.11258 11.0562 8.15321 11.0968C8.19384 11.1374 8.21667 11.1925 8.21667 11.25",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.7832 11.25C7.7832 11.1925 7.80603 11.1374 7.84666 11.0968C7.8873 11.0562 7.94241 11.0333 7.99987 11.0333",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99987 11.4667C7.94241 11.4667 7.8873 11.4438 7.84666 11.4032C7.80603 11.3626 7.7832 11.3075 7.7832 11.25",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.21667 11.25C8.21667 11.3075 8.19384 11.3626 8.15321 11.4032C8.11258 11.4438 8.05746 11.4667 8 11.4667",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 9.29996V5.3999",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAlert;
